import { Form } from 'app/models/form.model';
import { FormsActions, FormsActionTypes } from '../actions/forms.actions';

export interface State {
  data: Form[];
  loaded: boolean;
  loading: boolean;

}

export const initialState: State = {
  loaded: false,
  loading: false,
  data: []
};

export function reducer(state = initialState, action: FormsActions): State {

  switch (action.type) {
    case FormsActionTypes.LoadFormsData:
      return { ...state, loaded: false, loading: true };
    case FormsActionTypes.LoadFormsDataSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload
      };
    case FormsActionTypes.LoadFormsDataFail:
      return { ...state, loaded: false, loading: false };
    }
    return state;
}

export const getForms = (state: State) => state.data;
export const getFormsLoaded = (state: State) => state.loaded;
export const getFormsLoading = (state: State) => state.loading;



